import React from 'react';
import { Paper } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SwitchBox } from '../../molecules/switch-box';
import { ValueBox } from '../../molecules/value-box';
import { FlexibilityTest } from '../../organisms/flexibility/flexibility-command-test';

import { Group } from '../../organisms/group';
import { ServiceAccessInput } from '../../organisms/settings/service-access-input';
import { useSelector } from '../../store/utils';
import { FlexibilityCommandType } from '../../shared';

const DevBezDodavatele = () => {
  const [serviceActive, regionNuts, activeCommand] = useSelector(
    ({ variables }) =>
      [
        variables.SERVICE_ACTIVE,
        variables.REGION_NUTS,
        variables.FLEXIBILITY_ACTIVE_COMMAND,
      ] as const
  );

  if (!serviceActive) {
    return (
      <Group
        layout="list"
        title={
          <FormattedMessage
            id="dev_homepage.title"
            defaultMessage="Vývojové menu"
          />
        }
      >
        <ServiceAccessInput />
      </Group>
    );
  }

  return (
    <>
      <Group
        layout="list"
        title={
          <FormattedMessage
            id="bez_dodavatele.title"
            defaultMessage="bezDodavatele"
          />
        }
      >
        <SwitchBox
          switchVariableId="BEZ_DODAVATELE_API_ENABLED"
          title={
            <FormattedMessage
              id="bez_dodavatele.enabled"
              defaultMessage="Integrace zapnuta"
            />
          }
          fullWidth
        />
        <ValueBox
          type="row"
          title={
            <FormattedMessage
              id="bez_dodavatele.region"
              defaultMessage="Kód kraje"
            />
          }
          value={regionNuts}
        />
      </Group>

      <Group
        layout="list"
        title={
          <FormattedMessage
            id="bez_dodavatele.business_flexibility.title"
            defaultMessage="Obchodní flexibilita"
          />
        }
      >
        <FlexibilityTest type={FlexibilityCommandType.BezDodavatele} />

        <Paper>{JSON.stringify(activeCommand)}</Paper>
      </Group>
    </>
  );
};

export default DevBezDodavatele;
